require('./alert-modal.component.scss');

export const AlertModalController = function(
  $scope,
  $modalInstance,
  errorStatus,
  errorText,
  errorConfig,
  $http,
  PermissionService,
  RouterService,
) {
  $scope.errorStatus = errorStatus;

  $scope.errorText = errorConfig ? `${errorText}

  Location:
  ${RouterService.$location.url()}

  Ajax:
  ${errorConfig? JSON.stringify({
    method: errorConfig.method,
    url: errorConfig.url,
    params: errorConfig.params,
  }, null, 4) : ''}` : errorText;

  $scope.cancel = () => $modalInstance.close();
  $scope.is500 = () => $scope.errorStatus == 500;
  $scope.isErrConfig = () => !!errorConfig;
  $scope.titleText = $scope.is500() ? gettext('Ошибка сервера') + ' : 500' : $scope.errorStatus;
  $scope.textButton = $scope.is500() ? gettext('Закрыть') : gettext('Ок');

  $scope.sendErr = () => {
    const url = '//staffcop.ru/crashreport/';
    const message = {
      url: url,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: $.param({
        version: PermissionService.serverVersion,
        serial: PermissionService.serial,
        body: $scope.errorText
      })
    };

    $http(message).then(
      res => {
        if (errorConfig) {
          errorConfig.resultData = res.data;
          errorConfig.resultError = false;
        }
        console.log('Sent message:', message, 'Ticket number:', res.data);
        $modalInstance.close();
      },
      err => {
        if (errorConfig) {
          errorConfig.resultData = false;
          errorConfig.resultError = err;
        }
        console.error('Cannot sent message:', err);
        $modalInstance.close();
      }
    );
  };

  // $modalInstance.dismiss('cancel');
};



// WEBPACK FOOTER //
// ./src/core/alert-modal/alert-modal.component.js